import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { supervisorAPI } from '../../services/api';

const SupervisorDashboard = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('claims');
    const [claims, setClaims] = useState([]);
    const [scholars, setScholars] = useState([]);
    const [loading, setLoading] = useState(true);
    const [scholarsLoading, setScholarsLoading] = useState(false);

    useEffect(() => {
        fetchClaims();
    }, []);

    useEffect(() => {
        if (activeTab === 'scholars' && scholars.length === 0) {
            fetchScholars();
        }
    }, [activeTab]);

    const fetchClaims = async () => {
        try {
            console.log('[FRONTEND] Fetching claims from API...');
            const response = await supervisorAPI.getClaims();
            console.log('[FRONTEND] API Response:', response.data);
            setClaims(response.data.claims || []);
        } catch (error) {
            console.error('Error fetching claims:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchScholars = async () => {
        setScholarsLoading(true);
        try {
            const response = await supervisorAPI.getScholars();
            setScholars(response.data.scholars || []);
        } catch (error) {
            console.error('Error fetching scholars:', error);
        } finally {
            setScholarsLoading(false);
        }
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';
        let date;
        if (timestamp.toDate) {
            date = timestamp.toDate();
        } else if (timestamp._seconds !== undefined) {
            date = new Date(timestamp._seconds * 1000);
        } else if (timestamp.seconds !== undefined) {
            date = new Date(timestamp.seconds * 1000);
        } else {
            date = new Date(timestamp);
        }
        if (isNaN(date.getTime())) return 'N/A';
        return date.toLocaleDateString('en-IN', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const statusBadge = (status, type) => {
        const styles = {
            ongoing: { background: '#dcfce7', color: '#166534' },
            completed: { background: '#dbeafe', color: '#1e40af' },
            suspended: { background: '#fef9c3', color: '#854d0e' },
            terminated: { background: '#fee2e2', color: '#991b1b' },
            pursuing: { background: '#ede9fe', color: '#5b21b6' },
        };
        const key = (status || '').toLowerCase();
        const s = styles[key] || { background: '#f3f4f6', color: '#374151' };
        return (
            <span style={{
                ...s,
                padding: '2px 10px',
                borderRadius: '12px',
                fontSize: '0.75rem',
                fontWeight: '600',
                textTransform: 'capitalize'
            }}>
                {status || '-'}
            </span>
        );
    };

    if (loading) return <div className="loading">Loading...</div>;

    return (
        <div className="app-container">
            {/* Sidebar */}
            <div className="sidebar">
                <div style={{ marginBottom: '2rem' }}>
                    <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#ffffff' }}>TRF System</h2>
                    <p style={{ fontSize: '0.875rem', color: '#ffffff' }}>Supervisor Portal</p>
                </div>

                <nav className="nav-menu">
                    <div className="nav-item">
                        <span
                            className={`nav-link${activeTab === 'claims' ? ' active' : ''}`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setActiveTab('claims')}
                        >
                            Manage Claims
                        </span>
                    </div>
                    {/*<div className="nav-item">
                        <span
                            className={`nav-link${activeTab === 'scholars' ? ' active' : ''}`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setActiveTab('scholars')}
                        >
                            Manage Scholars
                        </span>
                    </div>*/}
                </nav>

                <div style={{ marginTop: 'auto', paddingTop: '2rem', borderTop: '1px solid #e5e7eb' }}>
                    <div style={{ marginBottom: '1rem' }}>
                        <p style={{ fontSize: '0.875rem', fontWeight: '600', color: '#ffffff' }}>{user.fullName}</p>
                        <p style={{ fontSize: '0.75rem', color: '#ffffff' }}>{user.email}</p>
                        <p style={{ fontSize: '0.75rem', color: '#ffffff', marginTop: '0.25rem' }}>{user.department}</p>
                    </div>
                    <button onClick={logout} className="btn btn-secondary" style={{ width: '100%' }}>
                        Logout
                    </button>
                </div>
            </div>

            {/* Main Content */}
            <div className="main-content">

                {/* ── Manage Claims Tab ── */}
                {activeTab === 'claims' && (
                    <>
                        <div className="header">
                            <div>
                                <h1 style={{ fontSize: '1.875rem', fontWeight: '700', color: '#1f2937' }}>Manage Claims</h1>
                                <p style={{ color: '#6b7280' }}>Review and approve monthly claims</p>
                            </div>
                        </div>

                        <div className="dashboard-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)', marginBottom: '2rem' }}>
                            <div className="stat-card">
                                <div className="stat-value">{claims.length}</div>
                                <div className="stat-label">Pending Claims</div>
                            </div>
                            <div className="stat-card info">
                                <div className="stat-value">₹{claims.reduce((sum, c) => sum + (c.claim_amount || 0), 0).toLocaleString()}</div>
                                <div className="stat-label">Total Amount</div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-header">
                                <h2 className="card-title">Claims Pending Approval</h2>
                            </div>
                            <div className="card-body">
                                {claims.length === 0 ? (
                                    <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
                                        No claims pending approval
                                    </p>
                                ) : (
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Scholar Email</th>
                                                <th>Month/Year</th>
                                                <th>Amount</th>
                                                <th>Submitted On</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {claims.map(claim => (
                                                <tr key={claim.id}>
                                                    <td>{claim.user_email}</td>
                                                    <td>{claim.claim_month} {claim.claim_year}</td>
                                                    <td>₹{claim.claim_amount?.toLocaleString()}</td>
                                                    <td>{formatDate(claim.created_at)}</td>
                                                    <td>
                                                        <button
                                                            onClick={() => navigate(`/supervisor/claim/${claim.id}`)}
                                                            className="btn btn-primary"
                                                            style={{ fontSize: '0.75rem', padding: '0.25rem 0.75rem' }}
                                                        >
                                                            Review
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </>
                )}

                {/* ── Manage Scholars Tab ── */}
                {activeTab === 'scholars' && (
                    <>
                        <div className="header">
                            <div>
                                <h1 style={{ fontSize: '1.875rem', fontWeight: '700', color: '#1f2937' }}>Manage Scholars</h1>
                                <p style={{ color: '#6b7280' }}>Scholars assigned to you</p>
                            </div>
                        </div>

                        <div className="dashboard-grid" style={{ gridTemplateColumns: 'repeat(1, 1fr)', marginBottom: '2rem' }}>
                            <div className="stat-card">
                                <div className="stat-value">{scholars.length}</div>
                                <div className="stat-label">Assigned Scholars</div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-header">
                                <h2 className="card-title">Scholar Details</h2>
                            </div>
                            <div className="card-body">
                                {scholarsLoading ? (
                                    <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>Loading scholars...</p>
                                ) : scholars.length === 0 ? (
                                    <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
                                        No scholars assigned to you
                                    </p>
                                ) : (
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>TCE Roll No</th>
                                                <th>Department</th>
                                                <th>Supervisor</th>
                                                <th>Fellowship Status</th>
                                                <th>Ph.D. Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {scholars.map(s => (
                                                <tr key={s.id}>
                                                    <td>{s.name}</td>
                                                    <td>{s.rollno}</td>
                                                    <td>{s.dept}</td>
                                                    <td>{s.supervisor}</td>
                                                    <td>{statusBadge(s.fellowshipStatus)}</td>
                                                    <td>{statusBadge(s.phdStatus)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default SupervisorDashboard;
